var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "bg-image-wrapper",
      style: { backgroundColor: _vm.bgColor },
    },
    [
      _c("img", { staticStyle: { display: "none" }, attrs: { src: _vm.src } }),
      _vm._v(" "),
      _c("div", {
        staticClass: "bg-image",
        class: {
          "image-loaded": _vm.loaded,
          "blur-effect": _vm.blur,
          "opacity-effect": _vm.effect === "opacity",
        },
        style: { backgroundImage: "url(" + _vm.imageSrc + ")" },
      }),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/js/components/bg-image/bg-image.vue